import { render, staticRenderFns } from "./welcomeUser.vue?vue&type=template&id=2ead5a0f&"
import script from "./welcomeUser.vue?vue&type=script&lang=js&"
export * from "./welcomeUser.vue?vue&type=script&lang=js&"
import style0 from "./welcomeUser.vue?vue&type=style&index=0&id=2ead5a0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports